import { AreaTexto, Campo, Entrada, Selecao } from '../../componentes/ui.jsx';

/**
 * O formulario de uma OS / ficha, montado a partir dos campos do modelo.
 *
 * Nao conhece nenhum campo pelo nome: cada TIPO tem o seu controle. Campo
 * novo no servidor (modules/registros/modelos.js) aparece aqui sozinho; tipo
 * novo pede um `case` abaixo e um em `normalizarValor` na API.
 *
 * @param {object}   p
 * @param {object[]} p.campos     como /api/registros/modelos descreve
 * @param {object}   p.valores    `{ chave: valor }`
 * @param {object}   [p.origem]   `{ chave: 'ia' | 'humano' }` — marca o que a IA preencheu
 * @param {(chave: string, valor: unknown) => void} p.aoMudar
 */
export function FormularioRegistro({ campos, valores, origem = {}, aoMudar, desabilitado = false }) {
  return (
    <div className="reg-form">
      {campos.map((c) => (
        <div key={c.chave} className={c.tipo === 'texto_longo' ? 'reg-form__largo' : undefined}>
          <Campo
            rotulo={
              <>
                {c.rotulo}
                {origem[c.chave] === 'ia' && (
                  <span className="reg-ia" title="Preenchido pela IA na conversa">
                    IA
                  </span>
                )}
              </>
            }
            obrigatorio={c.obrigatorio}
            dica={c.ajuda}
          >
            <Controle campo={c} valor={valores[c.chave]} aoMudar={(v) => aoMudar(c.chave, v)} desabilitado={desabilitado} />
          </Campo>
        </div>
      ))}
    </div>
  );
}

function Controle({ campo, valor, aoMudar, desabilitado }) {
  const texto = valor ?? '';
  switch (campo.tipo) {
    case 'texto_longo':
      return <AreaTexto rows={3} value={texto} disabled={desabilitado} onChange={(e) => aoMudar(e.target.value)} />;
    case 'numero':
      return (
        <Entrada
          type="number"
          value={texto}
          disabled={desabilitado}
          onChange={(e) => aoMudar(e.target.value === '' ? '' : Number(e.target.value))}
        />
      );
    case 'data':
      return <Entrada type="date" value={texto} disabled={desabilitado} onChange={(e) => aoMudar(e.target.value)} />;
    case 'opcao':
      return (
        <Selecao value={texto} disabled={desabilitado} onChange={(e) => aoMudar(e.target.value)}>
          <option value="">—</option>
          {campo.opcoes.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </Selecao>
      );
    case 'sim_nao':
      return (
        <Selecao
          value={valor === true ? 'sim' : valor === false ? 'nao' : ''}
          disabled={desabilitado}
          onChange={(e) => aoMudar(e.target.value === '' ? '' : e.target.value === 'sim')}
        >
          <option value="">—</option>
          <option value="sim">Sim</option>
          <option value="nao">Não</option>
        </Selecao>
      );
    default:
      return <Entrada value={texto} disabled={desabilitado} onChange={(e) => aoMudar(e.target.value)} />;
  }
}
